import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {AuthorizeNetBatchDto} from "../../model/AuthorizeNetBatchDto";

export default class BatchController implements Ng1Controller {
    private error: any;
    private batches: AuthorizeNetBatchDto[] = [];

    $onInit(): void {
        this.refresh;
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.client.bindAllAuthorizeNetBatch(() => this.batches);
        $dataHub.onConnected(this.refresh);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;

        this.$dataHub.server.paymentBatchSubscribe();

    }

    sync = () => {
        this.$dataHub.server.paymentBatchSync()
            .catch(e => this.error = e);
    }
}
